module.exports = __webpack_public_path__ + "static/media/Gift.31d94a61.svg";